<template>
  <div>
    <Breadcrumb :options="breadcrumb" />

    <SearchField :form="formInline" :formCtrl="formCtrl" @onSearch="onSearch" @onReset="onReset"
      @onChange="onSearchItemChange">
      <!-- 表头设置控件 -->
      <template #right>
        <TableHeadSelect :config="formCtrlRight" :options="formCtrlRight.options" :inputValue="defaultTh"
          @onChange="onTableSelect" />
      </template>
    </SearchField>

    <Table ref="table" :tableData="tableData" :cols="cols" :page="page" :limit="limit" :total="total"
      @onSelectionChange="onSelectionChange" @onCurrentChange="onCurrentChange" @onSizeChange="onSizeChange">
      <template slot="codriverwork" slot-scope="params">
        <p v-for="(c, i) in (params.params.codriverwork.split('，'))" :key="'codriverwork' + i">{{ c }}</p>
      </template>
      <template slot="drivershortwork" slot-scope="params">
        <p v-for="(c, i) in (params.params.drivershortwork.split('，'))" :key="'drivershortwork' + i">{{ c }}</p>
      </template>
      <template slot="coescortwork" slot-scope="params">
        <p v-for="(c, i) in (params.params.coescortwork.split('，'))" :key="'coescortwork' + i">{{ c }}</p>
      </template>
      <template slot="escortshortwork" slot-scope="params">
        <p v-for="(c, i) in (params.params.escortshortwork.split('，'))" :key="'escortshortwork' + i">{{ c }}</p>
      </template>
    </Table>
  </div>
</template>

<script>
import tableMixin from "../../mixin/table";

export default {
  name: "StaffAttendanceSummary",
  mixins: [tableMixin],
  data() {
    return {
      baseUrl: 'carwork',
      breadcrumb: [
        { name: "考勤管理" },
        { name: "考勤汇总" },
      ],
      formInline: {
        fleet: '',
        month: '',
      },
      formCtrl: [
        {
          ...this.ctrls.month,
        },
        {
          ...this.ctrls.fleet,
          options: [],
          className: "carcap",
        },
        {
          ...this.ctrls.license,
        },
        /*{
          label: "开始天数：",
          keyName: "startday",
          placeholder: "请填写开始天数",
          type: "number",
        },
        {
          label: "结束天数：",
          keyName: "endday",
          placeholder: "请填写结束天数",
          type: "number",
        },*/
      ],
      cols: [
        { keyName: "license", label: "车牌号", minwidth: 110 },
        { keyName: "driverwork", label: "司机考勤", minwidth: 120 },
        { keyName: "escortwork", label: "押运考勤", minwidth: 120 },
        { keyName: "codriverwork", label: "打短司机考勤(公司)", slot: "codriverwork", minwidth: 120 },
        { keyName: "drivershortwork", label: "打短司机考勤(司机)", slot: "drivershortwork", minwidth: 120 },
        { keyName: "coescortwork", label: "打短押运考勤(公司)", slot: "coescortwork", minwidth: 120 },
        { keyName: "escortshortwork", label: "打短押运考勤(押运)", slot: "escortshortwork", minwidth: 120 },
      ],
      getListUrl: 'allrec',
      baseParams: ['month'],
    };
  },
  methods: {
    getOptions() {
      let url = `${this.baseUrl}/getfleet`;
      const params = {
        userid: this.user.id,
      }
      this.post(url, params, ({ msg, team, month }) => {
        if (msg == 'success') {
          this.setFleet({ team })
          this.$set(this.formInline, 'month', month || this.CURR_MONTH)
          this.$forceUpdate()
          this.getList()
        } else {
          this.$message({
            type: 'error',
            message: '获取数据失败，请稍后再试！'
          });
        }
      }, err => {
        console.log(err)
        this.$message({
          type: 'error',
          message: '获取数据失败，请稍后重试！'
        });
      })
    },
  },
  created() {
    const { user_group_id, id } = this.user
    if (user_group_id == 5) {
      this.formInline.fleet = id
      this.formCtrl.splice(1, 1)
      this.baseParams.push('fleet')
    }
    this.MONTH = this.CURR_MONTH
    this.$set(this.formInline, 'month', this.CURR_MONTH)
  },
  mounted() {
    this.getOptions();
    this.getList();
  },
};
</script>
<style lang="less" scoped>
/deep/ .fillet .el-form--inline .el-form-item:first-child {
  margin-right: 20px;

}

/deep/ .fillet .el-form--inline .el-form-item:nth-child(2) {
  margin-right: 0px;
  padding-right: 80px;
  position: relative;

  &::after {
    position: absolute;
    content: "";
    right: 40px;
    top: 6px;
    width: 1px;
    height: 28px;
    overflow: hidden;
    background-color: #EBEDF0;
  }
}

/*.carcap .el-input__inner {
  width: 122px;
  color: #303133;
  border: 1px solid #F4F6F7;
  background-color: #F4F6F7;
}*/
</style>